import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import AreasList from './AreasList';
import AreaN1DataService from "./services/arean1.service";
import Sidebar from './Sidebar';
import NoPrivileges from './NoPrivileges';
import ExportSidebar from './ProSideBar';
import { useDispatch, useSelector } from "react-redux";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import { PageHeader } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const AreasAuth = () => {
  const { user: currentUser } = useSelector((state) => state.auth) 
  // Admin role is id = 3
  // Superadmin role is id = 4
  return (
    (currentUser.roles.includes(4))?(<Areas />):
    <>
      <NoPrivileges currentUser={currentUser}/>
    </>
  )
}

class Areas extends Component {

  constructor(props) {
    super(props);
    this.onChangeAreaN1FilterByDescr = this.onChangeAreaN1FilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfAreasN1: null,
      LocationFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.LocationFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.LocationFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeAreaN1FilterByDescr(e) {
    this.setState({
      LocationFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.LocationFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    AreaN1DataService.getAreaN1ByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfAreasN1: response.data
        });
        console.log(this.state.listOfAreasN1);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />      
        <Container>
          <Row className='mb-2 d-flex'>
            <PageHeader />
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Areas</h5>
            <Col lg={true}>
              <FormLabel className='mb-2'>Filtrar por descripción:</FormLabel>       
              <FormControl type="text" name="filterbylocationinternalidentifier" id="filterbylocationinternalidentifier" onChange={this.onChangeAreaN1FilterByDescr}></FormControl>
            </Col>

            <Col lg={true}>
              <FormLabel className='mb-2'>Ordenar por:</FormLabel>       
                <FormControl as='select' onChange={this.onChangeSortField}>
                  <option value="id">Area N1 ID</option>
                  <option value="nombrearea">Area N1 descripción</option>
                </FormControl>
            </Col>
            
            <Col sm={true}>
              <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
              <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
            </Col>          
          </Row>
          <Link to="/new-arean1" className="mr-2 btn btn-secondary">Nueva Area N1</Link>            
          <Button className="m-2 btn btn-secondary">Exportar</Button>        
          <Row>
            <AreasList mode={0} listOfAreasN1 = {this.state.listOfAreasN1} />      
          </Row>
        </Container>
      </div>
      </>
    )
  }
}

export default AreasAuth;